const nl = {

    message: {

        title1: 'Afstandsbediening van smart home, technologie, veiligheid en gemoedsrust',

        content1:' AigoSmart helpt u bij het op afstand beheren en besturen van slimme huishoudelijke apparaten, en de apparaten kunnen elkaar ook waarnemen en linken. Met één klik kunnen verschillende huishoudelijke apparaten in uw vooraf ingestelde status gaan, waardoor u een veilig en zorgeloos slim huis voor u kunt creëren leven',

        title2:"AigoSmart is een nieuw submerk van Aigostar",

        content2:"De producten worden momenteel verkocht aan Spanje, Portugal, Frankrijk, Italië, Nederland, Duitsland, Finland, Denemarken, Polen, Rusland, Griekenland, Oostenrijk, Zwitserland, Tsjechië, Hongarije, Slowakije en andere Europese landen en regio's",

        content3:" AIGOSTAR's verschillende keuken-, was- en strijkmachines blijven kleine huishoudelijke apparaten bezetten",

        content4:" Top tien verkopen.",

        title3:"Brand Honour",

        content5:"Snel. Open. Innoveren. Volhouden",

        loading: 'Laden',

        submit: 'Verzenden',

        contactUs:"Neem contact met ons op",

        privacy:"Privacyovereenkomst",

        policy:"Servicebeleid",

        download:"Download",



    },

    "wisdomleads": {
        "title1": "Afstandsbediening van smart home, technologie, veiligheid en zorgen",
        "content1": "wisdomleads helpt u om slimme huishoudelijke apparaten op afstand te beheren en te besturen, en apparaten kunnen ook waarnemen en met elkaar communiceren.Met één klik trigger kunnen allerlei huishoudelijke apparaten uw vooraf ingestelde toestand binnengaan, waardoor een veilig en zorgeloos smart home leven voor u wordt gecreëerd.",
        "title2": "wisdomleads is een nieuw submerk van wisdomleads",
        "content2": "De producten worden momenteel verkocht aan Spanje, Portugal, Frankrijk, Italië, Nederland, Duitsland, Finland, Denemarken, Polen, Rusland, Griekenland, Oostenrijk, Zwitserland, Tsjechië, Hongarije, Slowakije en andere Europese landen en regio's.",
        "content3": "wisdomleads heeft een verscheidenheid aan keuken en was en strijken kleine huishoudelijke apparaten",
        "content4": "Top tien verkopen.",
        "title3": "Merkeer",
        "content5": "Snel te openen. Innovatie aandringen",
        "loading": "Laden",
        "submit": "Verzenden",
        "contactUs": "Neem contact met ons op",
        "privacy": "Privacy overeenkomst",
        "policy": "Dienstverleningsbeleid",
        "download": "download"
    },

    "v119": {
        "password": "wachtwoord",
        "back": "terugkeer",
        "account": "Vul de rekening in",
        "VerifyAccount": "Account verifiëren",
        "confire": "bevestigen",
        "complete": "compleet",
        "loginAccount": "Inloggen account",
        "VerifyCode": "Verificatiecode",
        "preview": "Vorige stap",
        "next": "Volgende stap",
        "enterEmail": "E-mail invoeren",
        "phone": "Mobiele aanmelding",
        "email": "Email login",
        "pleaseenter": "Gelieve in te voeren",
        "emailError": "Fout in e-mailformaat",
        "phoneError": "Fout bij het formatteren van mobiele nummers",
        "qcCodeError": "Fout in de verificatiecode",
        "sendCode": "Verificatiecode verzenden",
        "reSend": "Opnieuw verzenden",
        "tip1": "Voordat u de annuleringsaanvraag indient, controleert het platform de volgende informatie om de veiligheid van uw account en eigendom te waarborgen:",
        "tip2": "De rekening is in een veilige staat",
        "tip3": "Geen gevoelige handelingen zoals het binden van mobiele telefoons/e-mails, het wijzigen van wachtwoorden, het wijzigen van inloggeräten, enz. binnen 15 dagen",
        "tip4": "Account heeft geen actieve slimme apparaten",
        "tip5": "U bent offline (of ongebonden) op uw slimme apparaat",
        "tip6": "Rekening heeft geen eigendomsrisico",
        "tip7": "Geen gevoelige handelingen zoals het wijzigen van wachtwoorden, het kopen van records of het binden van bankkaarten binnen 15 dagen",
        "accountCancellation": "Annulering van de rekening",
        "tip8": "Bedankt voor je constante gezelschap. Helaas kan AigoSmart u geen diensten meer leveren. Voordat u uw account annuleert, zullen we uw account opnieuw controleren. Houd er rekening mee dat de volgende gegevens na succesvolle annulering worden verwijderd.",
        "tip9": "Bedankt voor je constante gezelschap. Wisdomleads kan u helaas geen diensten meer leveren. Voordat u uw account annuleert, zullen we uw account opnieuw controleren. Houd er rekening mee dat de volgende gegevens na succesvolle annulering worden verwijderd.",
        "tip10": "1. Intelligente module-, kamer-, thuis- en apparaatnetwerkinformatie zal permanent worden verwijderd en kan niet worden hersteld",
        "tip11": "2. Scenario's, automatisering, aangepaste recepten en andere informatie worden permanent verwijderd en kunnen niet worden hersteld",
        "tip13": "3. Alle accountinformatie, servicerecords, verbruiksstatus en andere informatie op het platform worden permanent verwijderd en kunnen niet worden hersteld",
        "tip14": "4. U kunt niet inloggen en dit AigoSmart-account gebruiken. Uw familie/vrienden kunnen geen apparaten met u delen via dit account",
        "tip14w": "4. U kunt niet inloggen en dit Wisdomleads-account gebruiken. Uw familie/vrienden kunnen geen apparaten met u delen via dit account",
        "tip15": "5. De persoonlijke informatie en historische berichten van uw AigoSmart-account (waaronder avatar, bijnaam, apparaatalarminformatie, platformpush, familieberichten, enz.) worden niet opgehaald",
        "tip15w": "5. De persoonlijke informatie en historische berichten van uw Wisdomleads-account (waaronder avatars, bijnamen, apparaatalarminformatie, platformpush, familieberichten, enz.) worden niet opgehaald",
        "tip16": "6. Voordat u deze rekening gebruikt, moet u de tegoeden van de rekening goed behandelen (punten, lidmaatschapsniveau, kwalificaties, bestellingen, coupons, rekwisieten en andere waardevolle diensten). Annuleren van de rekening wordt beschouwd als het opgeven van uw eigen en niet in staat om deze te blijven gebruiken. U begrijpt en gaat ermee akkoord dat AigoSmart u niet kan helpen bij het herstellen van de bovengenoemde diensten",
        "tip16w": "6. Voordat u deze rekening gebruikt, moet u de tegoeden van de rekening goed behandelen (punten, lidmaatschapsniveau, kwalificaties, bestellingen, coupons, rekwisieten en andere waardevolle diensten). Annuleren van de rekening wordt beschouwd als het opgeven van uw eigen en niet in staat om deze te blijven gebruiken. U begrijpt en gaat ermee akkoord dat Wisdomleads u niet kan helpen bij het herstellen van de bovengenoemde diensten",
        "tip17": "Het platform verwerkt uw aanvraag en verwijdert al uw gegevens binnen 15 dagen. Log niet binnen 15 dagen in op het platform om een succesvolle afmelding te garanderen",
        "tip18": "Voer de verificatiecode in",
        "tip12": "U kunt momenteel niet uitloggen",
        "tip20": "Suggesties voor het platform (facultatief)",
        "errorMsg1": "gebruiker bestaat niet",
        "errorMsg2": "Gebruiker heeft annulering aangevraagd",
        "errorMsg3": "Gebruikers mogen zich niet afmelden vanwege riskante handelingen binnen 15 dagen, zoals het wijzigen van wachtwoorden, het wijzigen van apparaten, enz.",
        "errorMsg4": "Foute verificatiecode",
        "tip21": "Wacht, mens-machine verificatie is aan de gang"
    }

}



export default nl;